import { getPurchaseTypeAll } from '@/controller/systemData'
import { Message } from 'element-ui'

/**
 * 采购类型数据模块
 * - 每次调用 getAllPurchaseTypes() 都从数据库查询，不使用缓存机制
 * - 下拉选项统一使用 shortName（简化名称）显示
 * - 显示配置表中所有 enabled=1 的数据
 * - 接口报错提示联系管理员
 */

// 当前会话最近一次加载的数据（供表格渲染函数同步查找使用）
let _latestList = []

// 获取全量采购类型数据（每次都从数据库查询，不缓存）
export function getAllPurchaseTypes() {
  return getPurchaseTypeAll().then(res => {
    if (res && res.code === '00' && res.body && res.body.length > 0) {
      _latestList = res.body
      return res.body
    } else {
      Message.error('获取采购类型数据失败，请联系管理员')
      return []
    }
  }).catch(() => {
    Message.error('获取采购类型数据失败，请联系管理员')
    return []
  })
}

// 格式化为 el-option 兼容格式 {value, label}，统一使用 shortName
export function formatForSelect(list) {
  if (!list || list.length === 0) return []
  return list.map(item => ({
    value: item.typeCode,
    label: item.shortName || item.typeName || item.typeCode
  }))
}

// 根据 typeCode 获取简化名称（优先从传入的list查找，否则从最近加载的数据查找）
export function getPurchaseTypeShortName(code, list) {
  const source = list || _latestList
  if (!source || !code) return code || ''
  const item = source.find(obj => obj.typeCode === code)
  if (item && item.shortName) return item.shortName
  if (item) return item.typeName
  return code
}

// 根据 typeCode 获取完整名称（优先从传入的list查找，否则从最近加载的数据查找）
export function getPurchaseTypeName(code, list) {
  const source = list || _latestList
  if (!source || !code) return code || ''
  const item = source.find(obj => obj.typeCode === code)
  if (item) return item.typeName
  return code
}
